import { type ReactNode } from "react";

export function Postcard({
  rotate = -2,
  className = "",
  onClick,
  children,
}: {
  rotate?: number;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={`relative bg-paper rounded-sm shadow-[0_8px_24px_-8px_rgba(26,22,18,0.35)] active:scale-[0.97] transition-transform ${className}`}
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      {/* Postmark in corner */}
      <div className="absolute top-1.5 right-1.5 opacity-40">
        <svg width="26" height="26" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="20" stroke="#1A1612" strokeWidth="1.2" strokeDasharray="2 3" />
          <path d="M8 24 H40 M24 8 V40" stroke="#1A1612" strokeWidth="0.6" />
        </svg>
      </div>
      {children}
    </button>
  );
}
